import * as React from "react";
import { Notification } from "react-admin";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme();

const AdminLayout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <div style={{ width: "100%" }}>
      {children}
      <Notification />
    </div>
  </ThemeProvider>
);

export default AdminLayout;
